
import { createElement } from "react";
import React from "react";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";

export function SectionLabel(props) {
    return reactElement("div", {
        className: join(" ", ["text-[11px]", "font-semibold", "text-[#777777]", "uppercase", "tracking-[.05em]"]),
        children: props.Text,
    });
}

export function SidebarSection(props) {
    let elems;
    return reactElement("div", createObj(ofArray([["data-test-id", props.TestId], ["className", join(" ", toList(delay(() => append(singleton("flex"), delay(() => append(singleton("flex-col"), delay(() => append(singleton("gap-3"), delay(() => (!props.IsFirst ? append(singleton("border-t"), delay(() => append(singleton("border-[#EAEAEA]"), delay(() => singleton("pt-[18px]"))))) : empty()))))))))))], (elems = toList(delay(() => append(singleton(createElement(SectionLabel, {
        Text: props.Label,
    })), delay(() => props.Children)))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function DetailItem(props) {
    let elems;
    return reactElement("div", createObj(ofArray([["data-test-id", props.TestId], ["className", join(" ", ["flex", "flex-col", "gap-[2px]"])], (elems = [reactElement("div", {
        className: join(" ", ["text-[12px]", "text-[#777777]"]),
        children: props.Label,
    }), reactElement("div", {
        className: join(" ", ["text-[14px]"]),
        children: props.Value,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

